import { Directive, HostBinding, Input } from '@angular/core';

export enum AvailableStyles {
  green,
  bordered,
  'bordered-green',
  yellow,
}

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: '[UIKitLabel]',
})
export class LabelDirective {
  @Input() styles: string[] = [];

  @HostBinding('class')
  get classes() {
    return `label ${this.styles.map((style: string) => `label_${style}`).join(' ')}`;
  }
}
